module.exports = __webpack_public_path__ + "img/client-hospital-veterinario.e736ea1b.jpg";